<template>
  <div
    class="modifier-group__min-max"
    :class="{
      'modifier-group__min-max_invalid': !isValid,
      'modifier-group__min-max_hidden': indicatorIsHidden
    }"
  >
    {{ display }}
  </div>
</template>

<script>
export default {
  name: "ModifierGroupMinMaxIndicator",
  props: {
    group: Object
  },
  computed: {
    indicatorIsHidden() {
      return !this.group?.minModifiers || !this.group?.multipleChoice;
    },
    display() {
      return this.group?.minModifiers ? `Select ${this.group?.minModifiers}` : null;
    },
    isValid() {
      return this.group?.selectedModifiers?.length >= this.group?.minModifiers;
    }
  }
};
</script>

<style lang="scss" scoped>
.modifier-group__min-max {
  margin-top: 10px;

  &_invalid {
    color: $error-color;
  }

  &_hidden {
    visibility: hidden;
    padding-bottom: 0;
  }
}
</style>
